import {FormGroup} from "@angular/forms";

export function EmailValidator(email: string, formSubmitted: boolean, errorElementName: string) {
    return (formGroup: FormGroup) => {
        if (errorElementName && formGroup.controls[errorElementName]) {
            const errorElement = formGroup.controls[errorElementName];
            errorElement.setErrors(null);

            if (formSubmitted) {
                if (email === null || email === undefined || email.length === 0) {
                    errorElement.setErrors({ invalid: true });
                } else {
                    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
                        /* email is good */
                    } else {
                        errorElement.setErrors({ invalid: true });
                    }
                }
            }
        }
        return null;
    };
}
